import { Component, HostBinding } from '@angular/core';

import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';

@Component({
	selector: 'copo-eorder',
	styleUrl: './eorder.component.css',
	templateUrl: './eorder.component.html',
})
export class EOrderComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	user: User;

	constructor(
		private readonly userService: UserService,
	) {
		this.user = this.userService.user;
	}
}
